import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfigService } from './api-config.service';
import { SubCategory } from '../../models/sub-category.interface';

@Injectable({
  providedIn: 'root'
})
export class SubCategoryService {
  private get apiUrl(): string {
    return `${this.apiConfig.apiUrl}/subcategories`;
  }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getSubCategories(category?: string, search?: string, active?: boolean | string): Observable<SubCategory[]> {
    let params = new HttpParams();
    if (category && category !== 'all') {
      params = params.set('category', category);
    }
    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }
    if (active !== undefined && active !== 'all') {
      params = params.set('active', String(active));
    }
    return this.http.get<SubCategory[]>(this.apiUrl, { params });
  }

  getSubCategory(idOrSlug: string): Observable<SubCategory> {
    return this.http.get<SubCategory>(`${this.apiUrl}/${idOrSlug}`);
  }

  createSubCategory(subCategory: Partial<SubCategory>): Observable<SubCategory> {
    return this.http.post<SubCategory>(this.apiUrl, subCategory);
  }

  updateSubCategory(id: string, subCategory: Partial<SubCategory>): Observable<SubCategory> {
    return this.http.put<SubCategory>(`${this.apiUrl}/${id}`, subCategory);
  }

  deleteSubCategory(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}
